import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { TranslateModule } from '@ngx-translate/core';

import { MainInfoComponent } from './main-info.component';
import { CustomMapAutocompleteModule } from '@hiptraveler/features/custom-map-autocomplete';

const MODULES = [
  CommonModule,
  ReactiveFormsModule,
  MatFormFieldModule,
  MatInputModule,
  TranslateModule
];

const LIBRARIES = [
  CustomMapAutocompleteModule
];

const COMPONENTS = [
  MainInfoComponent
];

@NgModule({
  imports: [
    MODULES,
    LIBRARIES
  ],
  declarations: [
    COMPONENTS
  ],
  exports: [
    MainInfoComponent
  ]
})
export class MainInfoModule { }
